import React from 'react';
import { Button } from '../components/ui/button';
import ContactButton from '../components/ContactButton';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-cream">
      <header className="fixed top-0 w-full z-50 bg-charcoal/95 backdrop-blur-md border-b border-warmSage/20">
        <nav className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center space-x-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_fashion-empire-2/artifacts/bcsdxd12_IMG_2797.PNG" 
                alt="PRSVR Logo" 
                className="h-10"
                style={{ filter: 'brightness(0) saturate(100%) invert(98%) sepia(6%) saturate(214%) hue-rotate(327deg) brightness(102%) contrast(96%)' }}
              />
            </a>
            <Button onClick={() => window.location.href = '/'} variant="ghost" className="text-cream">Back to Home</Button>
          </div>
        </nav>
      </header>

      <div className="container mx-auto px-6 pt-32 pb-16 max-w-4xl">
        <h1 className="text-5xl font-black text-charcoal uppercase mb-8">Terms of Service</h1>
        <p className="text-warmGray mb-8">Effective Date: {new Date().toLocaleDateString()}</p>

        <div className="space-y-8 text-charcoal">
          <section>
            <h2 className="text-2xl font-bold mb-4">1. Agreement to Terms</h2>
            <p className="text-warmGray leading-relaxed">By accessing or using PRSVR's website and services, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">2. Products and Services</h2>
            <p className="text-warmGray leading-relaxed mb-4">PRSVR offers fashion apparel, custom team uniforms, and related products. All product descriptions, images, and specifications are approximate and for general information only.</p>
            <p className="text-warmGray leading-relaxed">We reserve the right to limit quantities, discontinue products, or refuse service to anyone at our discretion.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">3. Custom Orders</h2>
            <p className="text-warmGray leading-relaxed mb-4"><strong>Customer Responsibility:</strong> You are responsible for providing accurate information including player names, numbers, sizes, and logo files. PRSVR is not liable for errors in customer-provided information.</p>
            <p className="text-warmGray leading-relaxed mb-4"><strong>Order Confirmation:</strong> All custom orders require review and approval before production begins. You have 48 hours to review and approve order details.</p>
            <p className="text-warmGray leading-relaxed"><strong>Production Timeline:</strong> Standard orders take 3-5 weeks. Rush orders (additional $350) take 10-12 business days. Timelines may vary based on order complexity and quantity.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">4. Pricing and Payment</h2>
            <p className="text-warmGray leading-relaxed mb-4">All prices are in USD and subject to change without notice. Payment is required at time of order. We accept payments through Shopify's secure payment processing.</p>
            <p className="text-warmGray leading-relaxed">Additional fees may apply for logo design ($100), rush orders ($350), or special customizations.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">5. Shipping and Delivery</h2>
            <p className="text-warmGray leading-relaxed mb-4">Shipping costs and delivery times vary based on location and shipping method selected. We are not responsible for delays caused by shipping carriers, customs, or force majeure events.</p>
            <p className="text-warmGray leading-relaxed">Risk of loss passes to you upon delivery to the carrier.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">6. Intellectual Property</h2>
            <p className="text-warmGray leading-relaxed mb-4">All content on this website, including designs, logos, text, and images, is the property of PRSVR and protected by copyright and trademark laws.</p>
            <p className="text-warmGray leading-relaxed">You grant PRSVR a non-exclusive license to use any logos or designs you provide for the purpose of creating your custom products.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">7. Limitation of Liability</h2>
            <p className="text-warmGray leading-relaxed">PRSVR is not liable for any indirect, incidental, special, or consequential damages arising from your use of our products or services. Our total liability shall not exceed the amount you paid for the product.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">8. Modifications to Terms</h2>
            <p className="text-warmGray leading-relaxed">We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting. Continued use of our services constitutes acceptance of modified terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">9. Governing Law</h2>
            <p className="text-warmGray leading-relaxed">These Terms are governed by the laws of California, United States, without regard to conflict of law principles.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">10. Contact Information</h2>
            <div className="bg-charcoal text-cream p-6 rounded-lg">
              <p className="font-bold mb-2">PRSVR</p>
              <p>Email: info@prsvr.com</p>
              <p>Phone: (661) 553-2186</p>
            </div>
          </section>
        </div>
      </div>
      <ContactButton />
    </div>
  );
};

export default TermsOfService;